// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"path","attrs":{"fill":"props.filledColor","d":"M22.5 20L1.5 20L1.5 18H22.5V20ZM22.5 4V16H16.5L16.5 4L22.5 4ZM15 4L15 16L9 16L9 4L15 4ZM7.5 4L7.5 16L1.5 16L1.5 4L7.5 4Z"}}]};

const TabFilledIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'tab-filled',
    ref,
    icon: element,
  },
));

TabFilledIcon.displayName = 'TabFilledIcon';

export default TabFilledIcon;
